import { showBreakerRound } from "services/util";

export const getPreviousPage = (
  quiz: any,
  customer: any,
  teams: any,
  progress: any
) => {
  const { section, page, round, position } = progress;
  const rounds = quiz.quizConfig?.format.rounds || 8;
  const questions = quiz.quizConfig?.format.questionCount || 10;
  const isCrossword = quiz.quizConfig?.format?.isCrossword || false;
  const hasBreaker = quiz.quizConfig?.format?.hasBreaker || false;
  const assignedPrizes = customer.assignedPrizes || [];
  // const teams = teams || [];

  switch (section) {
    case "question":
      if (page === "question") {
        if (position === 0) {
          return { page: "intro" };
        } else {
          return { position: position - 1 };
        }
      } else {
        if (round !== 1) {
          return {
            section: "result",
            round: round - 1,
            page: "team",
            // position: round === 1 ? 2 : 3,
          };
        }
      }
      break;

    case "crossword":
      if (page === "intro") {
        return {
          section: "result",
          page: "round",
        };
      } else if (page === "question") {
        // if((round === 5 && hasBreaker) || (round === 4 && rounds === 4 && hasBreaker)){
        //   return {
        //     section: "answer",
        //     page: "question",
        //     position: questions-1,
        //   }
        // } else {
        return {
          section: "question",
          page: "question",
          position: questions - 1,
        };
        // }
      } else {
        return { page: "intro" };
      }

    // case "breaker":
    //   if (page === "answer") {
    //     return { page: "question" }
    //   } else {
    //     if (isCrossword) {
    //       return {
    //         section: "crossword",
    //         page: "question"
    //       };
    //     } else {
    //       return {
    //         section: "question",
    //         page: "question",
    //         position: questions-1,
    //       };
    //     }
    //   }

    case "breaker":
      if (page === "answer-answer") {
        return { page: "answer-question" };
      } else if (page === "answer-question") {
        return {
          section: "answer",
          page: "question",
          position: questions - 1,
        };
      } else {
        if (isCrossword) {
          return {
            section: "crossword",
            page: "question",
          };
        } else {
          return {
            section: "question",
            page: "question",
            position: questions - 1,
          };
        }
      }

    case "ad":
      if (hasBreaker && showBreakerRound(quiz.quizConfig, round)) {
        return { section: "breaker", page: "question" };
      } else {
        if (isCrossword) {
          return {
            section: "crossword",
            page: "question",
          };
        } else {
          return {
            section: "question",
            page: "question",
            position: questions - 1,
          };
        }
      }

    case "answer":
      if (page === "intro") {
        if ([4, 5].includes(round) && hasBreaker) {
          return {
            section: "breaker",
            page: "question",
          };
        } else {
          if (isCrossword) {
            return {
              section: "crossword",
              page: "question",
            };
          } else {
            return {
              section: "question",
              page: "question",
              position: questions - 1,
            };
          }
        }
      } else {
        if (position !== 0) {
          return {
            page: "question",
            position: position - 1,
          };
        } else {
          return { page: "intro" };
        }
      }

    case "result":
      if (page !== "intro") {
        if (page === "aggregate-final" && round === rounds) {
          return {
            section: "winner",
            page: "prize",
            position: Math.min(assignedPrizes.length, teams.length) - 1,
          };
        } else if (round === 1 && page === "team") {
          return { page: "round" };
        } else if (round !== 1 && page === "team") {
          return { page: "aggregate" };
        } else if (page === "round") {
          return {
            section: "answer",
            page: "question",
            position: questions - 1,
          };
        } else if (page === "aggregate") {
          return { page: "round" };
        } else if (page === "crossword") {
          return { section: "crossword", page: "answer" };
        } else if (page === "final") {
          return { page: "aggregate-final" };
        }
      } else {
        if (
          (round === 5 && hasBreaker) ||
          (round === 4 && rounds === 4 && hasBreaker)
        ) {
          // return {
          //   section: "breaker",
          //   page: "answer",
          // };
          return {
            section: "breaker",
            page: "answer-question",
          };
        } else {
          return {
            section: "answer",
            page: "question",
            position: questions - 1,
          };
        }
      }
      break;

    case "winner":
      if (page === "prize") {
        if (position !== 0) {
          return { position: position - 1 };
        } else {
          return { page: "intro" };
        }
      } else {
        if (isCrossword) {
          return {
            section: "crossword",
            page: "answer",
          };
        } else {
          return {
            section: "result",
            page: "round",
          };
        }
      }

    default:
      break;
  }
};
